<template>
  <v-card>
    <v-card-title>メニュー値設定</v-card-title>
    <v-card-text>
      <v-container>
        <!--{{ returnData }}-->
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="移動ページ名"
              v-model="returnData.text"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select
              label="リンク"
              v-model="returnData.to"
              :items="menu"
              item-text="display"
              item-value="path"
              required
              @change="initText"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-select
              label="アクセス制限"
              v-model="accessRole"
              item-text="label"
              item-value="value"
              :items="select"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-select
              label="アクセス条件"
              v-model="rules[1]"
              item-text="label"
              item-value="value"
              :items="selectRule"
            ></v-select>
          </v-col>
          <v-col cols="2" v-if="rules[1] == 'userFormID'">
            <v-text-field
              label="対象formID"
              v-model="rules[2]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="2" v-if="rules[1] == 'userFormID'">
            <v-select
              label="比較演算子"
              v-model="rules[3]"
              item-text="label"
              item-value="value"
              :items="comparison"
            ></v-select>
          </v-col>
          <v-col cols="2" v-if="rules[1] == 'userFormID'">
            <v-select
              label="比較対象"
              v-model="rules[4]"
              item-text="label"
              item-value="value"
              :items="selectRule2"
            ></v-select>
          </v-col>
          <v-col cols="2" v-if="rules[1] == 'userFormID'">
            <v-text-field label="値" v-model="rules[5]" required></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select
              :items="$store.state.colors"
              v-model="returnData.color"
              label="ボタンの色"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :color="returnData.color + ' white--text'" @click="submit"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    //共通値
    type: Number,
    position: Number,
    //個別値
    text: String,
    to: String,
    routes: Array,
    role: String,
    color: String,
  },
  data() {
    return {
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        //個別値
        text: this.text,
        to: this.to,
        role: this.role,
        color: this.color,
      },
      accessRole: 0,
      rules: ["0"],
      menu: [],
      select: [
        { label: "全て(0)", value: 0 },
        { label: "管理者(1)", value: 1 },
        { label: "権限(2)", value: 2 },
      ],
      selectRule: [
        { label: "指定しない", value: "noRule" },
        { label: "ユーザ設定内の追加フォームの値", value: "userFormID" },
      ],
      selectRule2: [{ label: "指定した値", value: "value" }],
      comparison: [
        { label: "==", value: "==" },
        { label: "!=", value: "!=" },
      ],
    };
  },
  async mounted() {
    //routesを[]に変換
    let tmp = [];
    this.routes.forEach((r) => {
      let t = {
        path: r.path,
        title: r.title,
        display: r.title + " ｜" + r.path,
      };
      tmp.push(t);
    });
    this.menu = tmp;
    this.rules = this.role.split(",");
    this.accessRole = Number(this.rules[0]);
  },
  methods: {
    submit() {
      this.rules[0] = String(this.accessRole);
      this.returnData.role = this.rules.join(",");

      this.$emit("clickSubmit", this.returnData);
    },
    initText(t) {
      this.routes.map((r) => {
        if (r.path == t) {
          this.returnData.text = r.title;
          return;
        }
      });

      //
    },
  },
};
</script>
